/* eslint-disable */
import axios from 'axios'; 

export const cmsMixin = {
  data() {
    return {
      cms: {},
    };
  },

  mounted() {
    this.loadCMSData(); 
  },

  methods: {
    async loadCMSData() {
      try {
        // ERROR FIX 1: You were using 'data' before it was defined.
        // ERROR FIX 2: Axios returns the result in '.data' automatically. 
        // No need for 'await response.json()'.
        
        const response = await axios.get(`https://veritas.com.ph/vmc/api/content?_nocache=${new Date().getTime()}`);
        
        if (response.data) {
          this.cms = response.data;
          console.log("CMS Data Loaded Successfully");
        }
      } catch (error) {
        console.error("CMS Sync: Server offline or unreachable", error);
      }
    }
  }
};